// Import reducer.
import rootReducer from './rootReducer';

// Export reducer.
export default rootReducer;
